import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import styles from "./searchselect.module.css";

const SearchSelectContent = forwardRef((props, ref) => {
  const searchInputRef = useRef(null);
  const [search, setSearch] = useState("");

    /**
   * @type {string[]|{name: string, value: string}[]}
   */
  const data = useMemo(() => {
    return props.data.filter((item) => {
      const itemValue = typeof item === 'string' ? item : item.name;
      return itemValue.toLowerCase().includes(search.toLowerCase());
    });
  }, [props.data, search]);


  const handleSelect = (option) => {
    props.onSelect?.(option);
    setSearch("");
  }

  useEffect(() => {
    searchInputRef.current?.focus();
  }, [])

  return (
    <div 
      ref={ref}
      className={styles.content}
      style={{ position: 'fixed', top: props.top, left: props.left, width: props.width, zIndex: 999, opacity: props.positioned ? 1 : 0 }}
      data-placement={props.placement}
    >
      <div className={styles.contentInner}>
        <div>
          <input 
            ref={searchInputRef} 
            className={styles.inputSearch} 
            placeholder="Search list..." 
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className={styles.optionsContainer}>
          {data.length > 0 && data.map((item, index) => (
            <button key={index} className={styles.option} type="button" onClick={() => handleSelect(item)}>
              <span>
                {typeof item === 'string' ? item : item.name}
              </span>

              {props.value === (typeof item === 'string' ? item : item.name) && (
                <svg width="16" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"> 
                  <path d="M28.998 8.531l-2.134-2.134c-0.394-0.393-1.030-0.393-1.423 0l-12.795 12.795-6.086-6.13c-0.393-0.393-1.029-0.393-1.423 0l-2.134 2.134c-0.393 0.394-0.393 1.030 0 1.423l8.924 8.984c0.393 0.393 1.030 0.393 1.423 0l15.648-15.649c0.393-0.392 0.393-1.030 0-1.423z" fill="#626262"  />
                </svg>
              )}
            </button>
          ))}

          {data.length === 0 && (
            <div className={styles.noOptions}>No options found</div>
          )}
        </div>
      </div>
    </div>
  )
})

export default SearchSelectContent;